export enum SearchTypes {
  APPLICANTS = 'applicants',
  VACANCIES = 'vacancies'
}
